<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <div class="row">

    <div class="col-sm-4">
      <p>
        <label for="tp_fasc_lbl">Tipo fascicolo</label> <input id="tp_fasc_lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.tipoFascicolo ? fascicolo.tipoFascicolo.label : nomeFascicolo">
      </p>
    </div>
    <div class="col-sm-4">
      <p>
        <label for="posizione_lbl">Posizione</label> <input id="posizione_lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.posizione ? fascicolo.posizione : labelCreatoDaSistema">
      </p>
    </div>
    <div class="col-sm-4">
      <p>
        <label for="otats_lbl">Stato</label> <input id="otats_lbl" class="form-control" type="text" disabled=""
          [value]="fascicolo && fascicolo.stato ? fascicolo.stato.label : labelCreatoDaSistema">
      </p>
    </div>
  </div>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <div class="row">
    <div comboModInput class="col-sm-4"
              [labelInput] = "'Visibilit&agrave;'"
              formControlName = "tipoVisibilita"
              [labelNoSelection] = "'Ereditata dalla pratica'"
              [labelOption] = "'label'"
              [optionsCombo] = "tipiVisibilitaOptions"
              [objectReference]="request.fascicolo.tipoVisibilita"
              [mandatory]="true"
              (onReturn)="request.fascicolo.tipoVisibilita = $event;
              datiGeneraliForm.controls['tipoVisibilita'].setValue($event) ">
    </div>
    <div datePickerInput class="{{(!inserimento) ? 'col-sm-3' : 'col-sm-4'}}" [labelInput]="'Data inizio'"
      formControlName="dataInizioFascicolo" [dataAl]="request.fascicolo.dataDefinizione"
      [control]="datiGeneraliForm.controls['dataInizioFascicolo']" [(ngModel)]="request.fascicolo.dataInizioFascicolo"
      [mandatory]="true"></div>

    <div comboModInput class="{{(!inserimento) ? 'col-sm-3' : 'col-sm-4'}}" [labelInput]="'Natura'" [mandatory]="true"
      [control]="datiGeneraliForm.controls['natura']" formControlName="natura" [labelOption]="'label'"
      [ngModel]="request.fascicolo.natura" [objectReference]="request.fascicolo.natura"
      (onReturn)="request.fascicolo.natura = $event" [optionsCombo]="tipiNatura"></div>

    <div checkBoxRadio class="{{(!inserimento) ? 'col-sm-2' : 'col-sm-4'}}" [labelInput]="'Fondo rischi'"
      idInput="fondo_rischi" formControlName="flagFondoRischi" [objectReference]="request.fascicolo.flagFondoRischi"
      (onReturn)=" request.fascicolo.flagFondoRischi = $event; changedFondoRischiState(); request.fascicolo.dataVariazioneFondoRischi=( ( !wizard && changeFondoRischi ) ? undefined : initialValueDVFR);">
    </div>

    <ng-template [ngIf]="!inserimento">
      <div datePickerInput class="col-sm-4" [submitPending]="wizard || !changeFondoRischi"
        [labelInput]="'Data variazione Fondo rischi'" formControlName="dataVariazioneFondoRischi"
        [mandatory]="!wizard && changeFondoRischi" [control]="datiGeneraliForm.controls['dataVariazioneFondoRischi']"
        [(ngModel)]="request.fascicolo.dataVariazioneFondoRischi"></div>
    </ng-template>
  </div>

    <!-- <div class="row">
      <div checkBoxRadio class="col-sm-3"
        [labelInput]="'Recupero crediti'" idInput="recupero_crediti"
        formControlName="recuperoCrediti" [objectReference]="request.fascicolo.recuperoCrediti"
        (onReturn)="request.fascicolo.recuperoCrediti = $event">
      </div>
    </div> -->


  <div class="row">
    <div comboModInput class="col-sm-3" [labelInput]="'Stato lavorazione'"
      [control]="datiGeneraliForm.controls['statoLavorazione']" formControlName="statoLavorazione"
      [labelOption]="'label'" [ngModel]="request.fascicolo.statoLavorazione"
      [objectReference]="request.fascicolo.statoLavorazione" (onReturn)="request.fascicolo.statoLavorazione = $event"
      [optionsCombo]="statoLavorazioneOptions"></div>

      <div textInput [control]="datiGeneraliForm.controls['nSinistro']" class="col-sm-3" [labelInput]="'N° sinistro'"
      formControlName="nSinistro" [(ngModel)]="request.fascicolo.nSinistro"></div>

    <div datePickerInput class="col-sm-3" [labelInput]="'Data sinistro'" formControlName="dataSinistro"
      [mandatory]="true" [control]="datiGeneraliForm.controls['dataSinistro']"
      [(ngModel)]="request.fascicolo.dataSinistro" [dataAl]="request.fascicolo.dataDenuncia"></div>

    <div datePickerInput class="col-sm-3" [labelInput]="'Data denuncia'" formControlName="dataDenuncia"
      [mandatory]="true" [control]="datiGeneraliForm.controls['dataDenuncia']" [dataDal]="request.fascicolo.dataSinistro"
      [(ngModel)]="request.fascicolo.dataDenuncia"></div>

  </div>

  <div class="row">

    <div class="form-group col-sm-3">
      <label for="tipoGestioneSinistro">Tipo gestione sinistro</label><span class="mandatory">*</span>
      <select formControlName="tipoGestioneSinistro"
        [(ngModel)]="request.fascicolo.tipoGestioneSinistro"
        class="form-control" id="tipoGestioneSinistro">
        <option [selected]="request.fascicolo.tipoGestioneSinistro == null || request.fascicolo.tipoGestioneSinistro == undefined" [ngValue]="null">Scegli...</option>
        <option [ngValue]="'DIRETTA'">Diretta</option>
        <option [ngValue]="'INDIRETTA'">Indiretta</option>
      </select>
    </div>

    <div comboModInput class="col-sm-3" [labelInput]="'Canale apertura'"
      [control]="datiGeneraliForm.controls['canaleApertura']" formControlName="canaleApertura"
      [labelOption]="'label'" [ngModel]="request.fascicolo.canaleApertura"
      [objectReference]="request.fascicolo.canaleApertura" (onReturn)="request.fascicolo.canaleApertura = $event"
      [optionsCombo]="canaliOptions"></div>

      <div class="form-group col-sm-3">
      <label for="tipoResponsabilita">RCT/RCO</label><span class="mandatory">*</span>
      <select formControlName="tipoResponsabilita"
        [(ngModel)]="request.fascicolo.tipoResponsabilita"
        class="form-control" id="tipoResponsabilita">
        <option [selected]="request.fascicolo.tipoResponsabilita == null || request.fascicolo.tipoResponsabilita == undefined" [ngValue]="null">Scegli...</option>
        <option [ngValue]="'RCT'">RCT</option>
        <option [ngValue]="'RCO'">RCO</option>
      </select>
    </div>

    <div textInput [control]="datiGeneraliForm.controls['luogo']" class="col-sm-3" [labelInput]="'Luogo'"
      formControlName="luogo" [(ngModel)]="request.fascicolo.luogo"></div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Descrizione'" formControlName="descrizione"
    [(ngModel)]="request.fascicolo.descrizione"></div>
  </div>

  <div class="row">
    <div  textInput [control]="datiGeneraliForm.controls['protocolloDenuncia']" class="col-sm-3" [labelInput]="'Protocollo denuncia'"
      formControlName="protocolloDenuncia" [(ngModel)]="request.fascicolo.protocolloDenuncia" [maxLength]="25"></div>

    <div comboModInput class="col-sm-3" [labelInput]="'Presidio/Distretto'"
      [control]="datiGeneraliForm.controls['presidioDistretto']" formControlName="presidioDistretto"
      [labelOption]="'label'" [ngModel]="request.fascicolo.presidioDistretto"
      [objectReference]="request.fascicolo.presidioDistretto" (onReturn)="request.fascicolo.presidioDistretto = $event"
      [optionsCombo]="tipiPresidiOptions"></div>

    <div comboModInput class="col-sm-3" [labelInput]="'Tipo di danno'"
      [control]="datiGeneraliForm.controls['tipoDanno']" formControlName="tipoDanno" [labelOption]="'label'"
      [ngModel]="request.fascicolo.tipoDanno" [objectReference]="request.fascicolo.tipoDanno"
      (onReturn)="request.fascicolo.tipoDanno = $event" [optionsCombo]="tipiDannoOptions"></div>
    <div comboModInput class="col-sm-3" [labelInput]="'Tipo valutazione'"
      [control]="datiGeneraliForm.controls['tipoDanno']" formControlName="tipoValutazione" [labelOption]="'label'"
      [ngModel]="request.fascicolo.tipoValutazione" [objectReference]="request.fascicolo.tipoValutazione"
      (onReturn)="request.fascicolo.tipoValutazione = $event" [optionsCombo]="tipoValutazioneOptions"></div>
  </div>

  <div class="row">
    <div class="col-sm-3" >
      <p><label for="decesso_lbl">Decesso</label>
        <select id="decesso_lbl" [(ngModel)]="request.fascicolo.morte" class="form-control"	formControlName="morte" >
        <option [selected]="request.fascicolo.morte == null || request.fascicolo.morte == undefined" [ngValue]="null">Non specificato</option>
        <option [ngValue]="true">Decesso</option>
        <option [ngValue]="false">Lesione</option>
        </select>
      </div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
      [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi" class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)">
      </p>
    </div>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
														(!request.fascicolo.flagFondoRischi && !inserimento && !wizard ? !request.fascicolo.dataVariazioneFondoRischi : false) ||
														( (changeFondoRischi && !request.fascicolo.dataVariazioneFondoRischi) && ( !inserimento ) && ( !wizard ) ) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
